import { AppId } from '@inno-tools/container-bridge'

export const APP_META_TAGS_DATA: Record<
  AppId,
  { title: string; faviconPathName: string }
> = {
  [AppId.ACCOUNTING]: {
    title: 'Accounting',
    faviconPathName: 'accounting'
  },
  [AppId.AFTER_SALES]: {
    title: 'innoscripta CRM',
    faviconPathName: 'innoscripta-crm'
  },
  [AppId.BULK_MAILING]: {
    title: 'Bulk Mailing',
    faviconPathName: 'bulk-mailing'
  },
  [AppId.BYTE_BUILDER]: {
    title: 'Byte Builder',
    faviconPathName: 'byte-builder'
  },
  [AppId.APPLICATION_STUDIO]: {
    title: 'Application Studio',
    faviconPathName: 'byte-builder'
  },
  [AppId.CALENDAR]: {
    title: 'Calendar',
    faviconPathName: 'calendar'
  },
  [AppId.CLUSTER_CLOUD]: {
    title: 'Cluster Cloud',
    faviconPathName: 'cloud'
  },
  [AppId.CLUSTER_CODE]: {
    title: 'Code',
    faviconPathName: 'code'
  },
  [AppId.CLUSTER_FILES]: {
    title: 'Files',
    faviconPathName: 'files'
  },
  [AppId.CLUSTER_DOCS]: {
    title: 'Documents',
    faviconPathName: 'docs'
  },
  [AppId.CLUSTER_CELLS]: {
    title: 'Cells',
    faviconPathName: 'spreadsheet'
  },
  [AppId.CLUSTER_SLIDES]: {
    title: 'Slides',
    faviconPathName: 'slides'
  },
  [AppId.CLUSTER_PDF]: {
    title: 'PDFs',
    faviconPathName: 'pdf'
  },
  [AppId.CLUSTER_MEET]: {
    title: 'Cluster Meet',
    faviconPathName: 'meet'
  },
  [AppId.COMPANY_SEARCHER]: {
    title: 'Company Searcher',
    faviconPathName: 'company-searcher'
  },
  [AppId.CONTRACT_MANAGEMENT]: {
    title: 'Contract Management',
    faviconPathName: 'contract-management'
  },
  [AppId.EMAIL]: {
    title: 'Mail',
    faviconPathName: 'mail'
  },
  [AppId.EXTERNAL_FORMS]: {
    title: 'External Forms',
    faviconPathName: 'forms'
  },
  [AppId.GDPR]: {
    title: 'GDPR',
    faviconPathName: 'contacts'
  },
  [AppId.HR]: {
    title: 'HR',
    faviconPathName: 'hr'
  },
  [AppId.INTEGRATION]: {
    title: 'Integration',
    faviconPathName: 'integrations'
  },
  [AppId.INVENTORY]: {
    title: 'Inventory',
    faviconPathName: 'inventory'
  },
  [AppId.LIVE_CHAT]: {
    title: 'Chat',
    faviconPathName: 'messenger'
  },
  [AppId.MY_ORGANIZATION]: {
    title: 'My Organization',
    faviconPathName: 'organisations'
  },
  [AppId.PROFILE]: {
    title: 'Profile',
    faviconPathName: 'ai'
  },
  [AppId.PROJECT_MANAGEMENT]: {
    title: 'Project Management',
    faviconPathName: 'project-management'
  },
  [AppId.PROJECT_MANAGEMENT_V2]: {
    title: 'Project Management',
    faviconPathName: 'project-management'
  },
  [AppId.SALES]: {
    title: 'Sales',
    faviconPathName: 'sales'
  },
  [AppId.SETTINGS]: {
    title: 'Settings',
    faviconPathName: 'settings'
  },
  [AppId.SUBSIDIES]: {
    title: 'Subsidies',
    faviconPathName: 'subsidies'
  },
  [AppId.TASK_MANAGEMENT]: {
    title: 'Task Management',
    faviconPathName: 'task-management'
  },
  [AppId.TEMPLATE_MANAGER]: {
    title: 'Template Manager',
    faviconPathName: 'templates'
  },
  [AppId.TIMETRACKING]: {
    title: 'Time Tracking',
    faviconPathName: 'time-tracking'
  },
  [AppId.WORKFLOWS]: {
    title: 'Workflows',
    faviconPathName: 'workflows'
  },
  [AppId.COURSES]: {
    title: 'Courses',
    faviconPathName: 'courses'
  },
  [AppId.ONBOARDING]: {
    title: 'Onboarding',
    faviconPathName: 'onboarding'
  },
  [AppId.DOC_AI]: {
    title: 'Doc AI',
    faviconPathName: 'doc-ai'
  },
  [AppId.CLUSTER_SUPPORT]: {
    title: 'Cluster Support',
    faviconPathName: 'cluster-support'
  },
  [AppId.RISK_MANAGEMENT]: {
    title: 'Risk Management',
    faviconPathName: 'risk-management'
  },
  [AppId.ASSET_MANAGEMENT]: {
    title: 'Asset Management',
    faviconPathName: 'inventory'
  },
  [AppId.TRANSFER_PRICING]: {
    title: 'Transfer Pricing',
    faviconPathName: 'transfer-pricing'
  },
  [AppId.USAGE_ANALYTICS]: {
    title: 'Usage Analytics',
    faviconPathName: 'usage-analytics'
  },
  [AppId.INTEGRATION_V2]: {
    title: 'Integration',
    faviconPathName: 'integrations'
  },
  [AppId.IP_BOX]: {
    title: 'IP Box',
    faviconPathName: 'inventory'
  },
  [AppId.RECRUITING_AGENT]: {
    title: 'Recruiting Agent',
    faviconPathName: 'hr'
  },
  [AppId.ORDER_MANAGEMENT]: {
    title: 'Order Management',
    faviconPathName: 'inventory'
  }
}
